import React, { useEffect, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';
import './SumupPage.css';

const AFFILIATE_KEY = 'sup_afk_OO8A1KC3GvTAIrskEh486IWq9tUwLVXO';
const CALLBACK_URL = 'http://delifeed.com/melaba/sumup';

const SumupPage: React.FC = () => {
    const [searchParams] = useSearchParams();
    const total = searchParams.get('total');
    const smpStatus = searchParams.get('smp-status');
    const smpMessage = searchParams.get('smp-message');
    const smpTxCode = searchParams.get('smp-tx-code');
    const smpFailureCause = searchParams.get('smp-failure-cause');

    const anchorRef = useRef<HTMLAnchorElement | null>(null);

    const totalForLink = total ?? '2';

    useEffect(() => {
        // Auto-click only when `total` param is provided and there's no smp-status (i.e., initiating a payment)
        if (total && !smpStatus && anchorRef.current) {
            // small delay to ensure page renders
            const t = setTimeout(() => anchorRef.current?.click(), 150);
            return () => clearTimeout(t);
        }
    }, [total, smpStatus]);

    return (
        <div className="sumup-page">
            <h1>SumUp </h1>

            {smpStatus && (
                <div className={`smp-status ${smpStatus === 'success' ? 'success' : 'failed'}`}>
                    <h2>{smpStatus === 'success' ? 'Payment successful' : 'Payment failed'}</h2>
                    {smpMessage && <p className="smp-message">{smpMessage}</p>}
                    {smpFailureCause && <p><strong>Failure cause:</strong> {smpFailureCause}</p>}
                    {smpTxCode && <p><strong>Tx code:</strong> {smpTxCode}</p>}
                </div>
            )}

            <p className="sumup-temp">
                <a
                    ref={anchorRef}
                    href={`sumupmerchant://pay/1.0?affiliate-key=${AFFILIATE_KEY}&total=${encodeURIComponent(totalForLink)}&currency=GBP&title=DeliFeedFoodOrder&callback=${encodeURIComponent(CALLBACK_URL)}`}
                >
                    Start SumUp Payment
                </a>
            </p>

            <p className="sumup-note">If you provide <code>?total=12.34</code> in the query string, the link will be auto-clicked.</p>
        </div>
    );
};

export default SumupPage;
